import deFallbackTranslations from "../../assets/locales/de/translation.json";
import { getTypedValues } from "./functions/get-typed-values.function";

export const fallbackTranslationKeys: typeof deFallbackTranslations = getTypedValues(undefined, deFallbackTranslations);
